import React, { Component } from 'react';
import {
  Layout, Menu, Dropdown, Icon, Spin, Button
} from 'antd';
import {
  BrowserRouter as Router, Route, Redirect, Link,
} from 'react-router-dom';

import LoginContainer from './components/containers/LoginContainer';
import HomeContainer from './components/containers/HomeContainer';
import { app } from './base';

import 'antd/dist/antd.css';  // or 'antd/dist/antd.less'
import './App.css';
import logotiny from './images/logotiny.png';
import OrderListContainer from './components/containers/OrderListContainer';
import OrderDetailContainer from './components/containers/OrderDetailContainer';
import ProductListContainer from './components/containers/ProductListContainer';
const { Header, Sider, Content, Footer } = Layout;

function AuthenticatedRoute({ component: Component, authenticated, ...rest }) {
  return (
      <Route
          {...rest}
          render={
              (props) => {
                  if (authenticated === true) {
                      return <Component {...props} {...rest} />;
                  }
                  return <Redirect to={{ pathname: '/login' }} />;
              }
          }
      />
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      authenticated: false,
      currentUser: null,
    };
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    app.auth().signOut().then((user) => {
        this.setState({ currentUser: user, authenticated: false });
        return this;
    });
}

  componentWillMount() {
    this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
        console.log("auth change");
        console.log(user);
        if (user) {
            this.setState({
                authenticated: true,
                currentUser: user,
                loading: false,
            });
        } else {
            this.setState({
                authenticated: false,
                loading: false,
            });
        }
    });
  }

  componentWillUnmount() {
    this.removeAuthListener();
  }

  renderMenu() {
    return(
      <Menu
          theme="dark" mode="inline" defaultSelectedKeys={['1']}
      >
          <Menu.Item key="1">
              <Link to="/">
                  <Icon type="home" />
                  <span>
                      Home
                  </span>
              </Link>
          </Menu.Item>
          <Menu.Item key="2">
              <Link to="/orders">
                  <Icon type="book" />
                  <span>
                      Ordenes
                  </span>
              </Link>
          </Menu.Item>
          <Menu.Item key="3">
              <Link to="/products">
                  <Icon type="barcode" />
                  <span>
                      Productos
                  </span>
              </Link>
          </Menu.Item>
          <Menu.Item key="3">
              <Link to="/products" onClick={this.handleLogout}>
                  <Icon type="logout" />
                  <span>
                      Logout
                  </span>
              </Link>
          </Menu.Item>
      </Menu>
    );
  }

  renderRoutes() {
    return(
      <div className="generic-container">
                <Route
                    exact
                    path="/login"
                    render={() => <LoginContainer authenticated={this.state.authenticated} />}
                />

                <Route
                    path="/logout"
                    render={() => <Redirect to={{ pathname: '/' }} />}
                />
                
                <AuthenticatedRoute
                  exact
                  path="/order/:orderId"
                  authenticated={this.state.authenticated}
                  component={OrderDetailContainer}
                />

                <AuthenticatedRoute
                  exact
                  path="/orders"
                  authenticated={this.state.authenticated}
                  component={OrderListContainer}
                />

                <AuthenticatedRoute
                  exact
                  path="/products"
                  authenticated={this.state.authenticated}
                  component={ProductListContainer}
                />

                <AuthenticatedRoute
                    exact
                    path="/"
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    component={HomeContainer}
                />
            </div>
    );
  }

  render() {
    if (this.state.loading === true) {
      return (
          <div className="loading">
              <Spin size="large" />
          </div>
      );
    }

    return (
      <Router>
        <span>
            { this.state.authenticated && (
              <Layout style={{ minHeight: '100vh' }}>
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={this.state.collapsed}
                >
                    <div className="logo" style={{background: 'white',}}>
                        <img src={logotiny} alt="MID" width="40" />
                    </div>
                    {this.renderMenu()}
                </Sider>
                <Layout>
                    <Header className="menu-top-header" style={{ background: '#fff', padding: 0 }}>
                        <Icon
                            className="trigger"
                            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.toggle}
                        />
                        {/* // <Dropdown overlay={this.renderMenuTop}>
                        //     <Button style={{ marginLeft: 8 }}>
                        //         <Icon type="user" /> Perfil <Icon type="down" />
                        //     </Button>
                        // </Dropdown> */}
                    </Header>
                    <Content style={{ margin: '24px 16px 0' }}>
                        <div style={{ padding: 10, background: '#fff', minHeight: 360 }}>
                            <div className="container-fluid">
                                {this.renderRoutes()}
                            </div>
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'center' }}>
                        MID Project ©2018
                    </Footer>
                </Layout>
              </Layout>
            )}
            { !this.state.authenticated &&(
                <div className="info-container">
                    {this.renderRoutes()}
                </div>
            )}

        </span>
    </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js